import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { GuiasRejeitadasResumo, GuiasRejeitadasFiltro, GuiasRejeitadasOpcoesFiltro, Exportacao } from '@gestor-web/@core/api/ords/model';
import { Page } from '@gestor-web/app/shared/components';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const EMPTY_RESUMO: GuiasRejeitadasResumo = {
  rejeicao_arquivo: [],
  rejeicao_guia: [],
  rejeicao_item: [],
};

@Injectable()
export class GuiasRejeitadasService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getDataGoApi(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtro: GuiasRejeitadasFiltro,
    pageData: Page,
  ) {
    return this.simuladorGoApi
      .fetchGuiasRejeitadas({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        tp_seq_lancto: filtro?.tpSeqLancto ?? null,
        motivo_guia: filtro?.motivoGuia ?? [],
        motivo_item: filtro?.motivoItem ?? [],
        page: pageData.page,
        size: pageData.size,
      })
      .pipe(
        map(data => ({
          items: data.items ?? [],
          total: data.total ?? 0,
        })),
        catchError(() => of({ items: [], total: 0 })),
      );
  }

  getDataAgregadoGoApi(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtro: GuiasRejeitadasFiltro,
  ) {
    return this.simuladorGoApi
      .fetchGuiasRejeitadasAgregado({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        tp_seq_lancto: filtro?.tpSeqLancto ?? null,
        motivo_guia: filtro?.motivoGuia ?? [],
        motivo_item: filtro?.motivoItem ?? [],
      })
      .pipe(
        map(data => data ?? EMPTY_RESUMO),
        catchError(() => of(EMPTY_RESUMO)),
      );
  }

  getOpcoesFiltro(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchGuiasRejeitadasOpcoesFiltro({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(
        map(response => response?.items ?? { motivos_guia: [], motivos_item: [] }),
        catchError(() => of({ motivos_guia: [], motivos_item: [] } as GuiasRejeitadasOpcoesFiltro)),
      );
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchGuiasRejeitadasUltimoProcessamento({ regans });
  }

  getUltimoProcessamentoResumo(regans: string) {
    return this.simuladorGoApi.fetchGuiasRejeitadasResumoUltimoProcessamento({ regans });
  }

  requestExportacaoGoApi(regans: string, params: Exportacao) {
    return this.simuladorGoApi.requestExportacaoGuiasRejeitadas(regans, params);
  }

}
